import React from 'react';
import { Text } from '../'
import { useIntl } from 'react-intl'
import { StyledDiv, StyledLogo, StyleFirstRow, StyledButton, StyledSubText } from './footer.styled';
import LogoImg from '../../assets/images/amorim-logo-verde.svg';
import { IoEarthOutline } from 'react-icons/io5';
import { COLOR } from '../../assets';
import ICONVR from '../../assets/icons/icon-vr360.svg'

const FooterComponent = ({ updateShowLanguage, language, showLanguage, paddingTop }) => {
  const { primary, secondary, quinary } = COLOR;
  const intl = useIntl();
  return (
    <StyledDiv paddingTop={paddingTop}>
      <StyleFirstRow>
        <StyledLogo src={LogoImg}/>
        <StyledButton active={showLanguage} onClick={() => updateShowLanguage(true) }>
          <p>{String(language).toLocaleUpperCase()}</p>
          <IoEarthOutline fill={(showLanguage ? secondary : primary)}/>
        </StyledButton>
      </StyleFirstRow>

      <div onClick={() => window.open('https://www.amorimcorkflooring.pt/termos-de-uso', '_blank')} className="cursor-pointer"><Text
        className="mb-2"
        fontSize="10px"
        fontSizeMobile="8px"
        fontWeight="bold"
        color={quinary}
        textId="footer.terms-and-conditions"
        letterSpacing="0.4px"
      /></div>
      <StyledSubText>
        {intl.formatMessage({ id: "footer.powered-by"})} 
        <img alt='vr-icon' src={ ICONVR }></img>
      </StyledSubText>
    </StyledDiv>
  )
};

export default FooterComponent;
